import React from 'react';
import { useExpenseContext } from '../contexts/ExpenseContext.tsx';
import { useSettings } from '../contexts/SettingsContext';

const Header = () => {
  const { darkMode, toggleDarkMode } = useExpenseContext();
  const { currency, setCurrency, locale, setLocale } = useSettings();

  const handleCurrencyChange = (event) => {
    setCurrency(event.target.value);
  };

  const handleLocaleChange = (event) => {
    setLocale(event.target.value);
  };

  return (
    <header className="bg-white shadow-sm dark:bg-gray-800 transition-colors duration-200 sticky top-0 z-30">
      <div className="container mx-auto px-3 sm:px-4 py-3 sm:py-4 flex justify-between items-center border-b border-gray-200 dark:border-gray-700">
        <div className="flex items-center space-x-1 sm:space-x-2">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 sm:h-8 sm:w-8 text-blue-600 dark:text-blue-400" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1.5l-1.8-1.8A2 2 0 0012.2 2H7.8a2 2 0 00-1.4.6L4.5 4H4zm7 5a1 1 0 10-2 0v1H8a1 1 0 100 2h1v1a1 1 0 102 0v-1h1a1 1 0 100-2h-1V9z" clipRule="evenodd" />
          </svg>
          <h1 className="text-lg sm:text-xl font-bold text-gray-800 dark:text-white">Expense Tracker</h1>
        </div>
        <div className="flex items-center space-x-4">
          {/* Currency Selector */}
          <select
            value={currency}
            onChange={handleCurrencyChange}
            className="block py-1.5 px-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 rounded-lg text-sm text-gray-700 dark:text-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="USD">USD</option>
            <option value="EUR">EUR</option>
            <option value="GBP">GBP</option>
            <option value="INR">INR</option>
            {/* Add more currencies as needed */}
          </select>

          {/* Locale Selector */}
          <select
            value={locale}
            onChange={handleLocaleChange}
            className="block py-1.5 px-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 rounded-lg text-sm text-gray-700 dark:text-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="en-US">English (US)</option>
            <option value="en-GB">English (UK)</option>
            <option value="fr-FR">French (France)</option>
            <option value="es-ES">Spanish (Spain)</option>
            <option value="en-IN">English (India)</option>
            {/* Add more locales as needed */}
          </select>

          <button
            onClick={toggleDarkMode}
            className="p-2 rounded-md text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 transition-transform duration-150 active:scale-95"
            aria-label={darkMode ? "Switch to light mode" : "Switch to dark mode"}
            tabIndex={0}
          >
            {darkMode ? (
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 sm:h-6 sm:w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
              </svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 sm:h-6 sm:w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
              </svg>
            )}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
